import React from "react";
import { useParams } from "react-router-dom";
import CommentsManager from "./CommentsManager";
import { Header } from "../components/Header";

export default function CommentsWindow() {
  const params = useParams();
  let commentId = params.commentId;

  return (<>
    <Header/>
    <h1 className="centering">{commentId ? `Комментарий №${commentId}` : "Список полученных комментариев"}</h1>
    <br/>
    <CommentsManager commentId={commentId} />
  </>
  );

  
      
}
